import * as React from 'react';
import {DraftPeople, DraftPeopleStatusOptions} from '@models/draftPeople';
import {Select, Table} from 'antd';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import FormattedDateTime from "@components/custom/FormattedDateTime";
import {PaginationDefaultParams} from "../custom/Paginator";

type Props = {
    data: DraftPeople[],
    loading: boolean,
    intl: intlShape.isRequired
    currentPage: number;
    updateRequest: (item: DraftPeople) => void;
};


const DraftsPeopleTable: React.FC<Props> = props => {
    const {data, loading, currentPage, updateRequest} = props;
    const pageOffset = (currentPage - 1) * PaginationDefaultParams.count;
    const onChangeDraftPeopleStatus = (status, record) => {
        updateRequest({
            payload: [{value: status, path: "status", "op": "replace", "from": ""}],
            params: {id: record.props.recorddata.id},
            patch: true
        })
    };

    const columns = [
        {
            title: <FormattedMessage id="app.index" defaultMessage={`Index`}/>,
            width: 30,
            dataIndex: 'index',
            key: 'id',
            render: (a, b, i) => <span>{i + 1 + pageOffset}</span>
        },
        {
            title: <FormattedMessage id="app.person" defaultMessage={`Person`}/>,
            width: 150,
            dataIndex: 'person',
            key: 'person',
            render: (person: any) => <span>{person.name}</span>
        },
        {
            title: <FormattedMessage id="app.video_content_title" defaultMessage={`Video`}/>,
            width: 150,
            dataIndex: 'video_content',
            key: 'video_content',
            render: (video: any) => <span>{video.title}</span>
        },
        {
            title: <FormattedMessage id="app.role" defaultMessage={`Person Role`}/>,
            width: 150,
            dataIndex: 'person_role',
            key: 'person_role',
            render: (personRole: any) => <span>{personRole.title}</span>
        },
        {
            title: <FormattedMessage id="app.creation_date" defaultMessage={`Creation Date`}/>,
            width: 120,
            dataIndex: 'created_at',
            key: 'created_at',
            render: (text, record) => <FormattedDateTime date={text}/>
        },
        {
            title: <FormattedMessage id="app.status" defaultMessage={`Status`}/>,
            key: 'status',
            width: 30,
            dataIndex: 'status',
            render: (status, record) => (
                <Select className={status} value={status} onChange={onChangeDraftPeopleStatus}>
                    {DraftPeopleStatusOptions.map((opt, index) => (
                        <Select.Option key={`${record.id}_${index}`} value={opt.value}
                                       recorddata={record}>{opt.label}</Select.Option>
                    ))}
                </Select>
            )
        }
    ];
    return (
        <Table columns={columns}
               loading={loading}
               pagination={false}
               dataSource={data}
               rowKey='id'/>
    )
};

export default injectIntl(DraftsPeopleTable)